import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import React, { FC } from 'react';

const EditOutlined: FC<SvgIconProps> = (props) => (
  <SvgIcon
    fill="none"
    height="18"
    viewBox="0 0 18 18"
    width="18"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M3.89088 13.82C3.93106 13.82 3.97123 13.816 4.01141 13.81L7.39043 13.2174C7.43061 13.2093 7.46878 13.1912 7.4969 13.1611L16.0128 4.64526C16.0314 4.62667 16.0462 4.6046 16.0562 4.58029C16.0663 4.55599 16.0715 4.52994 16.0715 4.50363C16.0715 4.47732 16.0663 4.45126 16.0562 4.42696C16.0462 4.40266 16.0314 4.38058 16.0128 4.362L12.6739 1.02115C12.6357 0.98298 12.5855 0.962891 12.5313 0.962891C12.477 0.962891 12.4268 0.98298 12.3886 1.02115L3.8728 9.537C3.84266 9.56713 3.82458 9.60329 3.81655 9.64347L3.22391 13.0225C3.20437 13.1301 3.21135 13.2409 3.24426 13.3452C3.27716 13.4495 3.33499 13.5442 3.41275 13.6212C3.54534 13.7497 3.71208 13.82 3.89088 13.82ZM5.24489 10.3165L12.5313 3.03209L14.0038 4.50463L6.71744 11.789L4.9315 12.1044L5.24489 10.3165ZM16.3924 15.5075H1.60672C1.25114 15.5075 0.963867 15.7948 0.963867 16.1504V16.8736C0.963867 16.962 1.03619 17.0343 1.12458 17.0343H16.8746C16.963 17.0343 17.0353 16.962 17.0353 16.8736V16.1504C17.0353 15.7948 16.748 15.5075 16.3924 15.5075Z" />
  </SvgIcon>
);

export default EditOutlined;
